import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PlanCoupon from "../../components/planCoupon";
import { Box } from "biologiatotal-ui";
import BilletForm from "../../components/billetForm";
import FooterBuy from "../../components/footerBuy";
import CreditCard from "../../components/creditCard";
import CouponFree from "../../components/couponFree";
import Icon from "../../../components/icon";
import Tabbable from "../../../components/tabbable";
import ModalTerms from "../../components/modalTerms";
import RenderModal from "../../../components/renderModal";
import {
  couponCodeChange,
  doApplyCoupon,
  doSelectPlan,
  doPlansRequest,
  couponClear,
  doPay,
  doPayCouponFree,
  cleanDetails,
  doCepRequest
} from "../../state/actions";
import "./pay.scss";

const initialState = {
  billetPay: true,
  showFormPayment: false,
  plan: {},
  coupon: {},
  discounted: null,
  showModalTerms: false,
  currentPrice: "0,00",
  errorsFormPaymentCard: 0,
  errorsFormPaymentBillet: 0,
  errorsFormPaymentCoupon: 0
};

class Pay extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;

    this.cardRef = React.createRef();
    this.billetRef = React.createRef();
    this.CouponFreeRef = React.createRef();

    this.onCardPay = this.onCardPay.bind(this);
    this.onBilletPay = this.onBilletPay.bind(this);
    this.onCouponFreePay = this.onCouponFreePay.bind(this);
    this.onNext = this.onNext.bind(this);
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    this.setState({
      ...initialState
    });

    this.props.doPlansRequest().then(() => {
      if (this.props.cupomQuery) {
        this.props.couponCodeChange(this.props.cupomQuery);
        this.props.doApplyCoupon(this.props.cupomQuery);
      }
    });

    document.addEventListener("keyup", this.closeModal);

    setTimeout(() => {
      window.scrollTo({
        top: 0
      });
    }, 200);
  }

  componentDidUpdate() {
    document.addEventListener("keyup", this.closeModal);
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.closeModal);
  }

  closeModal = (event: any) => {
    if (event.keyCode === 27) {
      this.toggleModalTerms(false);
    }
  };

  toggleModalTerms = event => {
    this.setState({
      showModalTerms: event
    });
  };

  setCurrentPrice = price => {
    this.setState({
      currentPrice: price
    });
  };

  methodPay(billetPay, showFormPayment) {
    this.setState({
      ...this.state,
      billetPay,
      showFormPayment
    });
  }

  onSelectPlan(plan) {
    this.setState({
      ...this.state,
      plan
    });
  }

  onBilletPay(values) {
    const { user } = this.props;
    const { selectedPlan, coupon } = this.props.data;

    const fixed = {
      installments: 1,
      payment_method: "boleto",
      plan: selectedPlan.id,
      coupon: coupon && coupon.coupon ? coupon.coupon.id : undefined,
      user: user.id,
      name: user.name,
      email: user.email,
      ...values
    };

    const couponName = coupon && coupon.coupon ? coupon.coupon.code : "Sem cupom";

    this.props.doPay(fixed, "billet").then(
      () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "Assine",
          "assine-metodo_pagamento": "Boleto",
          "assine-plano": selectedPlan.title,
          "assine-cupom": couponName,
          "assine-valor": (coupon && coupon.installments["1"]) || Number(selectedPlan.price)
        });

        this.props.history.replace("/assine/finalizacao");
      },
      err => console.log(err)
    );
  }

  onCardPay(values) {
    const { user } = this.props;
    const { selectedPlan, coupon } = this.props.data;

    const card = {
      card_number: values.number,
      card_holder_name: values.name,
      card_expiration_date: values.expiry,
      card_cvv: values.cvc
    };

    const fixed = {
      card,
      payment_method: "credit_card",
      email: user.email,
      plan: selectedPlan.id,
      coupon: coupon && coupon.coupon ? coupon.coupon.id : undefined,
      user: user.id,
      ...values
    };

    const couponName = coupon && coupon.coupon ? coupon.coupon.code : "Sem cupom";

    this.props.doPay(fixed, "card").then(
      () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "Assine",
          "assine-metodo_pagamento": "Cartão",
          "assine-plano": selectedPlan.title,
          "assine-cupom": couponName,
          "assine-valor": (coupon && coupon.installments["1"]) || Number(selectedPlan.price)
        });

        this.props.history.replace("/assine/finalizacao");
      },
      err => console.log(err)
    );
  }

  onCouponFreePay(values) {
    const { user } = this.props;
    const { selectedPlan, coupon } = this.props.data;

    const fixed = {
      email: user.email,
      plan: selectedPlan.id,
      coupon: coupon ? coupon.coupon.id : undefined,
      user: user.id,
      ...values
    };

    this.props.doPayCouponFree(fixed).then(
      () => this.props.history.replace("/assine/finalizacao"),
      err => console.log(err)
    );
  }

  onNext() {
    const { data } = this.props;
    const { billetPay } = this.state;
    const couponFree = data.coupon && data.coupon.coupon.type === "total";

    if (couponFree) {
      this.CouponFreeRef.current.doPay();
    } else {
      if (billetPay) {
        this.billetRef.current.doPay();
      } else {
        this.cardRef.current.doPay();
      }
    }
  }

  logout = () => {
    const { cleanDetails } = this.props;

    // localStorage.removeItem("bt:accessTokenAdmin");
    cleanDetails();
  };

  validadeErrosFormCard = error => {
    this.setState({
      errorsFormPaymentCard: error
    });
  };

  validadeErrosFormBillet = error => {
    this.setState({
      errorsFormPaymentBillet: error
    });
  };

  validadeErrosFormCoupon = error => {
    this.setState({
      errorsFormPaymentCoupon: error
    });
  };

  render() {
    const { ui, data, doApplyCoupon, doSelectPlan, couponCodeChange, couponClear, doCepRequest } = this.props;
    const {
      showModalTerms,
      currentPrice,
      showFormPayment,
      billetPay,
      errorsFormPaymentCard,
      errorsFormPaymentBillet,
      errorsFormPaymentCoupon
    } = this.state;
    const couponFree = data.coupon && data.coupon.coupon.type === "total";
    const formPayError = billetPay ? errorsFormPaymentBillet : errorsFormPaymentCard;
    const disabledButtonFooterPay = !data.selectedPlan || !showFormPayment || formPayError > 0 ? true : false;
    const disabledButtonFooterCoupon = !data.selectedPlan || errorsFormPaymentCoupon > 0 ? true : false;
    const disabledButtonFooter = couponFree ? disabledButtonFooterCoupon : disabledButtonFooterPay;

    const methodFormPay = billetPay ? (
      <BilletForm
        displayName="BilletForm"
        ref={this.billetRef}
        plan={data.selectedPlan}
        onPay={this.onBilletPay}
        toggleModalTerms={this.toggleModalTerms}
        validadeErrosForm={this.validadeErrosFormBillet}
        doCepRequest={doCepRequest}
        viaCep={data.viaCep}
        isFetchingCep={ui.isFetchingCep}
      />
    ) : (
      <CreditCard
        ref={this.cardRef}
        plan={data.selectedPlan}
        onPay={this.onCardPay}
        installments={data.installments}
        toggleModalTerms={this.toggleModalTerms}
        validadeErrosForm={this.validadeErrosFormCard}
        doCepRequest={doCepRequest}
        viaCep={data.viaCep}
        isFetchingCep={ui.isFetchingCep}
      />
    );

    return (
      <Fragment>
        <section className="content-buy">
          <PlanCoupon
            couponCode={data.couponCode}
            onRemoveCoupon={couponClear}
            onCouponCodeChange={couponCodeChange}
            onSelectPlan={doSelectPlan}
            onApplyCoupon={doApplyCoupon}
            isApplyingCoupon={ui.isApplyingCoupon}
            selectedPlan={data.selectedPlan}
            isFetching={ui.isFetchingPlans}
            coupon={data.coupon}
            plans={data.plans}
            setCurrentPrice={this.setCurrentPrice}
          />

          <div className="columns is-multiline pay-method">
            <Box className="column centered pay-method-content is-12-mobile is-8-tablet is-8-desktop is-6-widescreen is-offset-2-tablet is-offset-2-desktop is-offset-3-widescreen">
              {couponFree ? (
                <CouponFree
                  ref={this.CouponFreeRef}
                  onPay={this.onCouponFreePay}
                  validadeErrosForm={this.validadeErrosFormCoupon}
                  toggleModalTerms={this.toggleModalTerms}
                />
              ) : (
                <Fragment>
                  <span className="pay-method-title">COMO VOCÊ QUER FAZER O PAGAMENTO?</span>
                  <span className="pay-method-subtitle">Escolha a forma de pagamento</span>

                  <div className="pay-method-actions">
                    <Tabbable className="pay-method-item" onClick={() => this.methodPay(false, true)}>
                      <Icon
                        icon="card"
                        width={64}
                        height={48}
                        className={`pay-method-icon ${showFormPayment && !billetPay ? "active" : ""}`}
                      />
                      <span className={`pay-method-type ${showFormPayment && !billetPay ? "active" : ""}`}>
                        Cartão de crédito
                      </span>
                    </Tabbable>
                    <Tabbable className="pay-method-item" onClick={() => this.methodPay(true, true)}>
                      <Icon
                        icon="bill"
                        width={64}
                        height={48}
                        className={`pay-method-icon ${showFormPayment && billetPay ? "active" : ""}`}
                      />
                      <span className={`pay-method-type ${showFormPayment && billetPay ? "active" : ""}`}>Boleto</span>
                    </Tabbable>
                  </div>

                  {showFormPayment && methodFormPay}
                </Fragment>
              )}
            </Box>
          </div>
        </section>
        <FooterBuy
          isNexting={ui.isPaying}
          onNext={this.onNext}
          sectionPayment={true}
          currentPrice={currentPrice}
          disabledNext={disabledButtonFooter}
          onBack={this.logout}
        />

        <RenderModal>{showModalTerms && <ModalTerms toggleModalTerms={this.toggleModalTerms} />}</RenderModal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.account,
    user: { ...state.app.data.user }
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      couponClear,
      doApplyCoupon,
      doSelectPlan,
      couponCodeChange,
      doPlansRequest,
      doPay,
      doPayCouponFree,
      cleanDetails,
      doCepRequest
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(Pay));
Routered.displayName = "Pay";

export default Routered;
